import AVALIACAO_SESSOES from './AVALIACAO_SESSOES';
import AVALIACAO_QUESTOES from './AVALIACAO_QUESTOES';

const { potencialidade_fiduciaria, conflitos_asg, condicoes_regulamentares } = AVALIACAO_SESSOES;

const xQuestoes = Object.values(AVALIACAO_QUESTOES);

const AVALIACAO_SESSOES_QUESTOES = {
  [potencialidade_fiduciaria.id]: {
    sessao_id: potencialidade_fiduciaria.id,
    sessao: potencialidade_fiduciaria.label,
    questoes: xQuestoes.filter(xQuestao => {
      return xQuestao.sessao_id === potencialidade_fiduciaria.id;
    })
  },
  [conflitos_asg.id]: {
    sessao_id: conflitos_asg.id,
    sessao: conflitos_asg.label,
    questoes: xQuestoes.filter(xQuestao => {
      return xQuestao.sessao_id === conflitos_asg.id;
    })
  },
  [condicoes_regulamentares.id]: {
    sessao_id: condicoes_regulamentares.id,
    sessao: condicoes_regulamentares.label,
    questoes: xQuestoes.filter(xQuestao => {
      return xQuestao.sessao_id === condicoes_regulamentares.id;
    })
  }
};

export default AVALIACAO_SESSOES_QUESTOES;
